import React, { useState } from 'react'
import styles from "./PostUsers.module.css"
import axios from 'axios'
import { API_URL } from "../../settings"
import { useAuth } from '../../Hooks/useAuth'
import popupAlert from './popupAlert'

const PostUsers = ({ selectedUsers }) => {
    const [ displayAlert, setDisplayAlert ] = useState()
    const { user } = useAuth()
    // Function to post selected signatures
    const onHandleSignaturesPost = () => {
        axios.post(`${API_URL}/users/group-email-signatures`, {selectedUsers}, { headers: { token: user.data.token}})
            .then(res => popupAlert(res.data.message, 'success'))
            .catch(error => {
                console.log(error)
                popupAlert('Error Posting Signatures', 'error')
            }) 
    } 

    return (
        <>
        <button className={styles.postUsersButton} disabled={selectedUsers.length < 1} onClick={() => setDisplayAlert(true)}>Save Selected Users</button>
        {
            displayAlert && 
            <div className={styles.modal}>
                <div className={styles.modalContent}>
                    <span className={styles.close} onClick={() => setDisplayAlert(false)}>&times;</span>
                    <h1 className={styles.modalTitle}>Are you sure you want to post these Users data?</h1>
                    <button className={styles.saveSignaturesButton} onClick={() => onHandleSignaturesPost()}>Save Signatures</button>
                    { selectedUsers.map(user => (<div key={user.email}><h5 className={styles.listItems}>{ user.email }</h5><hr /></div>)) }
                </div>
            </div>
        }
        </>
    )
}
export default PostUsers;